import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/app/ui/assets/svg/trash-red.svg'


const _hoisted_1 = { class: "w-full h-full bg-white" }
const _hoisted_2 = { class: "pt-4" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"flex items-center p-3 font-semibold text-gray-700 border rounded-t-md\"><div class=\"w-10\">No</div><div style=\"min-width:300px;width:500px;\">3LC</div><div style=\"min-width:300px;width:500px;\">District</div><div class=\"w-10\"></div></div>", 1)
const _hoisted_4 = { class: "border" }
const _hoisted_5 = { class: "w-10 pt-3" }
const _hoisted_6 = {
  class: "pr-4",
  style: {"min-width":"300px","width":"500px"}
}
const _hoisted_7 = { style: {"min-width":"300px","width":"500px"} }
const _hoisted_8 = { class: "w-10 pt-2" }
const _hoisted_9 = /*#__PURE__*/_createVNode("img", {
  class: "cursor-pointer w-5",
  src: _imports_0,
  alt: "trash-red"
}, null, -1)
const _hoisted_10 = { class: "flex justify-start border rounded-b-md p-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Title = _resolveComponent("Title")!
  const _component_SelectSearch = _resolveComponent("SelectSearch")!
  const _component_MultipleSelectSearchVirtualScroll = _resolveComponent("MultipleSelectSearchVirtualScroll")!
  const _component_Icons = _resolveComponent("Icons")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_Title, { label: "Area Delivery" }),
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode("div", _hoisted_4, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.form.partnerAreaDelivery, (item, index) => {
          return (_openBlock(), _createBlock("div", {
            key: index,
            class: "flex items-start py-2 border-b px-3"
          }, [
            _createVNode("div", _hoisted_5, _toDisplayString(index + 1), 1),
            _createVNode("div", _hoisted_6, [
              _createVNode(_component_SelectSearch, {
                placeholder: _ctx.$t('partnerManagement.choose3lc'),
                customValueStyle: "text-sm",
                keyValue: "code",
                keyName: "name",
                isLoading: _ctx.loadingGetCityList,
                options: _ctx.citiesList,
                modelValue: item.cityCode,
                "onUpdate:modelValue": ($event: any) => (item.cityCode = $event),
                onFilter: _ctx.fetchCityList,
                onChange: ($event: any) => (_ctx.handleCityChange(index)),
                onFocus: _ctx.handleFocusChangeCity,
                isDisabled: index === 0,
                disabledBackground: index === 0
              }, null, 8, ["placeholder", "isLoading", "options", "modelValue", "onUpdate:modelValue", "onFilter", "onChange", "onFocus", "isDisabled", "disabledBackground"])
            ]),
            _createVNode("div", _hoisted_7, [
              _createVNode(_component_MultipleSelectSearchVirtualScroll, {
                options: _ctx.districtMultipleData,
                onFilter: _ctx.filterDistrictMultiple,
                onFocus: ($event: any) => (_ctx.handleFocus(index)),
                modelValue: item.district,
                "onUpdate:modelValue": ($event: any) => (item.district = $event),
                keyName: "name",
                keyValue: "code",
                placeholder: _ctx.$t('courierManagement.searchDistrict'),
                "use-infinite-scroll": true,
                "show-select-all": true,
                "max-displayed-chips": 2,
                onLoadMore: ($event: any) => (_ctx.handleLoadMore(index)),
                "has-more-data": _ctx.hasMoredata,
                isDisabled: _ctx.districtDisabled(index) || index === 0,
                disableBackground: _ctx.districtDisabled(index) || index === 0,
                allEnabled: _ctx.searchValue === '',
                allSelectedValueShow: "",
                "preserve-all-selection-on-options-change": false
              }, null, 8, ["options", "onFilter", "onFocus", "modelValue", "onUpdate:modelValue", "placeholder", "onLoadMore", "has-more-data", "isDisabled", "disableBackground", "allEnabled"])
            ]),
            _createVNode("div", _hoisted_8, [
              _withDirectives(_createVNode("button", {
                onClick: ($event: any) => (_ctx.removePartnerAreaDelivery(index)),
                class: "self-center cursor-pointer ml-3 relative gap-1.5 flex flex-row items-center font-semibold text-red-lp-100 text-14px"
              }, [
                _hoisted_9
              ], 8, ["onClick"]), [
                [_vShow, index > 0]
              ])
            ])
          ]))
        }), 128))
      ]),
      _createVNode("div", _hoisted_10, [
        _createVNode(_component_Button, {
          class: `${_ctx.isAddButtonDisabled ? 'cursor-not-allowed text-gray-lp-500' : 'cursor-pointer text-red-lp-100'} flex gap-3`,
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isAddButtonDisabled ? {} : _ctx.addPartnerAreaDelivery()))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_Icons, {
              name: "plus-circle",
              class: `${_ctx.isAddButtonDisabled ? 'cursor-not-allowed text-gray-lp-500' : 'cursor-pointer text-red-lp-100'}`
            }, null, 8, ["class"]),
            _createTextVNode(" " + _toDisplayString(_ctx.$t('Tambah 3LC lainnya')), 1)
          ]),
          _: 1
        }, 8, ["class"])
      ])
    ])
  ]))
}